import * as CustomerSDK from '@livechat/customer-sdk'

/**
 *
 * @param {number} groupId
 * @returns {import('@livechat/customer-sdk').CustomerSDK}
 */
export function initLiveChatSDK(groupId) {
  // @ts-expect-error init type sessionData and license id as arguments
  // but it breaks init function in the way we are using it
  // it's a bug on their side
  const customerSDK = CustomerSDK.init({
    autoConnect: false,
    clientId: 'f0b21a3f79f5ab335c4a6661f38401de',
    groupId,
    organizationId: 'a2805e9c-4b8d-4312-8820-a5eaeb56e6f3',
  })

  // TODO: make async and add timeout so we ensure sdk is loaded

  return customerSDK
}
